import api from "./api";

export const validateShipment = async (shipmentId) => {
    if (!shipmentId) {
        throw new Error("Shipment ID is required");
    }

    const { data } = await api.get(
        `/blockchain/validate/${Number(shipmentId)}`
    );

    return data;
};

export default {
    validateShipment,
};